export default __webpack_public_path__ + "17ce344509a9a9fbc58c89f6886524d2.svg";